module.exports = __webpack_public_path__ + "img/wiki.3a932a26.png";